import React from 'react'
import { Loader } from 'src/shared'

export function GraphOrLoading(props) {
    if (props.loading)
        return <Loader/>
        
    return props.graph
}
